import { Star } from "lucide-react";
import { cn } from "@/lib/utils";

interface StarRatingProps {
  rating: number;
  max?: number;
  showText?: boolean;
  size?: "sm" | "md" | "lg";
}

const StarRating = ({ rating, max = 5, showText = true, size = "md" }: StarRatingProps) => {
  const sizeClasses = {
    sm: "h-3 w-3",
    md: "h-4 w-4",
    lg: "h-5 w-5"
  };

  return (
    <div className="flex items-center gap-1">
      {Array.from({ length: max }).map((_, i) => (
        <Star
          key={i}
          className={cn(
            sizeClasses[size],
            i < rating ? "fill-yellow-400 text-yellow-400" : "text-gray-300"
          )}
        />
      ))}
      {showText && (
        <span className="ml-2 text-sm text-muted-foreground">
          ({rating}/{max})
        </span>
      )}
    </div>
  );
};

export default StarRating;
